import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { cargarApiBaseUrl } from './services/apiConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Esperamos a resolver /config.json (API de esta franquicia) ANTES de
// renderizar — así ningún componente llega a leer API_BASE_URL vacío.
// .finally() asegura que la app arranca igual aunque config.json falle.
cargarApiBaseUrl().finally(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// Registra el service worker mínimo (sin caching) para que el navegador
// ofrezca instalar la app como PWA.
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
